import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';

export type AdminSection =
  | 'portal'
  | 'accounts'
  | 'network-devices'
  | 'users'
  | 'toggles'
  | 'kilns'
  | 'storage'
  | 'distributors'
  | 'terms'
  | 'phones-emails'
  | 'kiln-names'
  | 'maintenance-notes-stats'
  | 'alert-config-stats'
  | 'alert-delivery-failures'
  | 'login-failures'
  | 'kiln-claim-failures';

const ADMIN_SECTION_ROUTES: Record<AdminSection, string> = {
  portal: 'admin-portal',
  accounts: 'admin-account-list',
  'network-devices': 'admin-network-device',
  users: 'admin-users-page',
  toggles: 'admin-toggle',
  kilns: 'admin-kiln-search',
  storage: 'admin/storage',
  distributors: 'admin-distributors',
  terms: 'admin/terms-and-conditions',
  'phones-emails': 'admin-phones-emails',
  'kiln-names': 'admin-kiln-names',
  'maintenance-notes-stats': 'admin-maintenance-notes-stats',
  'alert-config-stats': 'admin-alert-config-stats',
  'alert-delivery-failures': 'admin-alert-delivery-failures',
  'login-failures': 'admin-login-failures',
  'kiln-claim-failures': 'admin-kiln-claim-failures',
};

@Injectable({
  providedIn: 'root',
})
export class AdminNavigationService {
  constructor(private navCtrl: NavController) {}

  navigate(section: string, currentSection?: string): void {
    if (section === currentSection) {
      return;
    }

    const route = ADMIN_SECTION_ROUTES[section as AdminSection];
    if (route) {
      void this.navCtrl.navigateForward(route);
    }
  }
}
